import SSBackgroundImage from "@core-components/backgroundImage/BackgroundImage";
import SSBgImageHeadline from "@core-components/backgroundImage/components/BgImageHeadline";
import SSContainer from "@core-components/container/Container";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import type { ReactNode } from "react";
import HelpCenterBackButton from "./HelpCenterBackButton";
import HelpCenterBackLink from "./HelpCenterBackLink";

interface IHelpCenterContainer {
  title: string;
  children?: ReactNode;
}

const HelpCenterContainer: React.FC<IHelpCenterContainer> = ({
  title,
  children = "",
}) => {
  return (
    <SSContainer className="help-center p-0 text-primary-white sm:px-5">
      <SSBackgroundImage>
        <SSContainer className="w-full items-center p-0 text-primary-white sm:px-5">
          <SSBgImageHeadline
            header={<HelpCenterBackLink />}
            props={{
              title: { ta: "center", order: 1, fz: 40 },
              stack: {
                className: "py-14 xs:py-[150px] items-center gap-16 !pb-11",
              },
              header: {
                className: "w-full",
              },
            }}
          >
            <SSWhiteText>{title}</SSWhiteText>
          </SSBgImageHeadline>
        </SSContainer>
      </SSBackgroundImage>

      <div className="relative">{children}</div>

      <HelpCenterBackButton />
    </SSContainer>
  );
};

export default HelpCenterContainer;
